module.exports = __webpack_public_path__ + "static/media/w_day.85587aaa.svg";